import { Swiper, Navigation, A11y, Pagination, Thumbs } from 'swiper';

export default () => {
  Swiper.use([Navigation, A11y, Pagination, Thumbs]);

  const defaultConfig = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 30,
    preloadImages: true,
    updateOnImagesReady: true,
    effect: 'fade',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  // Configuration overrides
  const configurations = new Map();

  configurations.set('upsell-slider', {
    direction: 'horizontal',
    centeredSlides: false,
    preloadImages: true,
    loop: false,
    updateOnImagesReady: true,
    slidesPerView: 'auto',
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.swiper-button-next-upsell',
      prevEl: '.swiper-button-prev-upsell',
    },
  });

  configurations.set('product-thumbs-slider', {
    direction: 'vertical',
    preloadImages: true,
    loop: false,
    spaceBetween: 10,
    updateOnImagesReady: true,
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    effect: 'fade',
    a11y: true,
    observer: true,
    observeParents: true,
    shortSwipes: false,
    navigation: {
      nextEl: '.swiper-button-next--thumb',
      prevEl: '.swiper-button-prev--thumb',
    },
  });

  configurations.set('product-slider', {
    direction: 'horizontal',
    centeredSlides: false,
    preloadImages: true,
    loop: false,
    spaceBetween: 10,
    updateOnImagesReady: true,
    slidesPerView: 'auto',
    effect: 'fade',
    a11y: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next--product',
      prevEl: '.swiper-button-prev--product',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  configurations.set('collection-product-slider', {
    direction: 'horizontal',
    preloadImages: true,
    spaceBetween: 20,
    updateOnImagesReady: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.js-slider--next',
      prevEl: '.js-slider--prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3.4,
        spaceBetween: 30,
      },
      1450: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  configurations.set('related-products-slider', {
    direction: 'horizontal',
    preloadImages: true,
    spaceBetween: 10,
    updateOnImagesReady: true,
    watchSlidesVisibility: true,
    slidesPerView: 2,
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.js-slider--next',
      prevEl: '.js-slider--prev',
    },
    breakpoints: {
      1400: {
        slidesPerView: 3,
      },
    },
  });

  // Init sliders
  const sliders = [...document.querySelectorAll('.js-slider')];
  sliders.forEach((sliderEl) => {
    let config = configurations.get(sliderEl.dataset.config);
    if (!config) {
      config = defaultConfig;
    }
    window.slider = {
      ...window.slider,
      [sliderEl.dataset.config]: new Swiper(sliderEl.querySelector('.swiper-container'), config),
    };
  });

  if (window.slider !== undefined) {
    if (window.slider['product-slider'] && window.slider['product-thumbs-slider']) {
      const mainSlider = window.slider['product-slider'];
      const thumbSlider = window.slider['product-thumbs-slider'];

      mainSlider.thumbs.swiper = thumbSlider;
      mainSlider.thumbs.init();
    }
  }
};
